import { AppMenu } from "./app-menu";
import { AppModule } from "./app-module";
import { Company } from "./company";
import { SystemField } from "./system-field";

export class Application extends SystemField{ 
    name?:string;
    icon?:string;
    company_id?:string;
    sys_id?:string;
    active?:number;
    is_default?:number;
    ordering?:number;
    target_link?:string;
    primary_color?:string;
    label?:string;

    menus?:AppMenu[];
    company?:Company; // parent relationship
    modules?:AppModule[];
    langs?:any;
}
export class AppTranslateModel extends SystemField{ 
    label?:string;
    description?:string;
    applications_id?:string;
    lang_code?:string;
}

